import { createTheme, LightTheme as theme } from 'baseui'

const primitives = {
  accent: '#276EF1',
  accent50: '#EFF3FE',
  accent100: '#D4E2FC',
  accent200: '#A0BFF8',
  accent300: '#5B91F5',
  accent400: '#276EF1',
  accent500: '#1E54B7',
  accent600: '#174291',
  accent700: '#102C60',
}

const overrides = {
  colors: {
    buttonPrimaryFill: primitives.accent500,
    buttonPrimaryText: '#FFFFFF',
    buttonPrimaryHover: primitives.accent600,
    buttonPrimaryActive: primitives.accent100,
    buttonPrimarySelectedFill: primitives.accent500,
    buttonPrimarySelectedText: '#FFFFFF',

    buttonSecondaryFill: theme.colors.positive100,
    buttonSecondaryText: theme.colors.positive500,
    buttonSecondaryHover: theme.colors.positive200,
    buttonSecondaryActive: theme.colors.positive100,
    buttonSecondarySelectedFill: theme.colors.positive200,
    buttonSecondarySelectedText: theme.colors.positive500,

    buttonTertiaryFill: 'transparent',
    buttonTertiaryText: '#000000',
    buttonTertiaryHover: '#F6F6F6',
    buttonTertiaryActive: '#EEEEEE',
    buttonTertiarySelectedFill: '#EEEEEE',
    buttonTertiarySelectedText: '#000000',
    buttonTertiarySpinnerForeground: '#333333',
    buttonTertiarySpinnerBackground: '#CBCBCB',

    buttonMinimalFill: 'transparent',
    buttonMinimalText: '#000000',
    buttonMinimalHover: '#F6F6F6',
    buttonMinimalActive: '#EEEEEE',
    buttonMinimalSelectedFill: '#EEEEEE',
    buttonMinimalSelectedText: '#000000',

    buttonDisabledFill: '#F6F6F6',
    buttonDisabledText: '#AFAFAF',

    fileUploaderBackgroundColor: '#F6F6F6',
    fileUploaderBackgroundColorActive: '#F6F6F6',
    fileUploaderBorderColorActive: '#000000',
    fileUploaderBorderColorDefault: '#CBCBCB',
    fileUploaderMessageColor: '#545454',

    linkText: '#000000',
    linkVisited: '#333333',
    linkHover: '#545454',
    linkActive: '#757575',

    inputBorder: '#EEEEEE',
    inputFill: '#EEEEEE',
    inputFillError: '#FFEFED',
    inputFillDisabled: '#F6F6F6',
    inputFillActive: '#F6F6F6',
    inputFillPositive: '#E6F2ED',
    inputTextDisabled: '#AFAFAF',
    inputBorderError: '#F1998E',
    inputBorderPositive: '#66D19E',
    inputEnhancerFill: '#EEEEEE',
    inputEnhancerFillDisabled: '#EEEEEE',
    inputEnhancerTextDisabled: '#AFAFAF',
    inputPlaceholder: '#757575',
    inputPlaceholderDisabled: '#AFAFAF',

    colorPrimary: '#000000',
    colorSecondary: '#545454',
    background: '#FFFFFF',
    backgroundAlt: '#FFFFFF',
    backgroundInv: '#000000',

    border: '#CBCBCB',
    borderAlt: '#AFAFAF',
    borderFocus: '#000000',
    borderError: '#E11900',

    backgroundPrimary: '#FFFFFF',
    backgroundSecondary: '#F6F6F6',
    backgroundTertiary: '#EEEEEE',

    contentPrimary: '#000000',
    contentSecondary: '#545454',
    contentTertiary: '#757575',
    contentInversePrimary: '#FFFFFF',
    contentInverseSecondary: '#CBCBCB',
    contentInverseTertiary: '#AFAFAF',

    contentAccent: '#276EF1',
    contentOnColor: '#FFFFFF',
    contentOnColorInverse: '#000000',
    contentNegative: '#E11900',
    contentWarning: '#BC8B2C',
    contentPositive: '#05944F',
  },
  borders: {
    buttonBorderRadius: theme.borders.radius200,
    inputBorderRadius: theme.borders.radius200,
    popoverBorderRadius: theme.borders.radius200,
    surfaceBorderRadius: theme.borders.radius200,
  },
}

export default createTheme(primitives, overrides)
